import styled from 'styled-components';

export const Card = styled.div`
  align-items: center;
  background: #90caf9;
  border: 6px solid #000000;
  border-radius: 8px;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0);
  cursor: pointer;
  display: flex;
  font-size: 80px;
  height: 130px;
  justify-content: center;
  margin: 0 4px;
  min-width: 90px;
  text-transform: capitalize;
  transition: all ease 0.5s;

  ${({ showLetter }) =>
    showLetter &&
    `
    color: #000000;
  `}
`;
Card.displayName = 'Card';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Oswald', sans-serif;
  font-size: 42px;
`;
Container.displayName = 'Container';

export const Sentence = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-family: 'Oswald', sans-serif;
  font-size: 42px;
  justify-content: center;
`;
Sentence.displayName = 'Sentence';

export const Time = styled.div`
  font-size: 24px;
  font-family: 'Noto Sans', sans-serif;
  padding: 8px 0;
  text-align: center;
`;
Time.displayName = 'Time';

export const Winner = styled.div`
  background: #90caf9;
  border: 6px solid #000000;
  border-radius: 8px;
  box-sizing: border-box;
  color: #000000;
  font-size: 40px;
  margin: 0 4px;
  padding: 0 1rem;
  text-align: center;
  transition: all ease 0.5s;
`;
Winner.displayName = 'Winner';

export const Word = styled.div`
  display: flex;
  margin: 8px 16px;
`;
Word.displayName = 'Word';
